import { render, staticRenderFns } from "./DTCCreate.vue?vue&type=template&id=532b91cd&"
import script from "./DTCCreate.vue?vue&type=script&lang=js&"
export * from "./DTCCreate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports